/**
 * Auto-detects the API base URL based on the current hostname
 * All subdomains use the same backend URL
 */
export const getApiBaseUrl = (): string => {
  let baseUrl;
  if (process.env.NODE_ENV === "development") {
    baseUrl = process.env.REACT_APP_DEV_API_URL;
  } else if (process.env.NODE_ENV === "production") {
    baseUrl = process.env.REACT_APP_API_URL;
  }

  return baseUrl || "http://localhost:3001";
};

export const API_BASE_URL = getApiBaseUrl();
